export const lightColors = {
  background_color: '#ffffff',
  text_color: '#000000',
}
